/* Keravive Tone Adapt CC Serum — PDP interactions (bundle + per-bottle shade + cart drawer) */
(function(){
  function ready(fn){document.readyState!='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var root=document; if(!root.querySelector('.cc-buybox')) return;
    var SHADES=['Light','Medium','Dark'];
    var SWATCH={Light:'#E4C7AE',Medium:'#B98F6C',Dark:'#7E5E48'};
    var VARIANTS=window.CC_VARIANTS||{};

    /* ---- Gallery ---- */
    var main=root.querySelector('.cc-gallery-main img'), thumbs=root.querySelectorAll('.cc-thumbs img');
    thumbs.forEach(function(t){
      t.addEventListener('click',function(){
        if(main){main.src=t.dataset.full||t.src;}
        thumbs.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
      });
    });

    /* ---- Bundle + shade (shade = a standard variant option, like a clothing size) ---- */
    var form=root.querySelector('form[action*="/cart/add"]');
    var idField=form?form.querySelector('input[name="id"]'):null;
    var bundles=root.querySelectorAll('.cc-bundle');
    var state={bundle:null,shade:'Light',variantId:null};

    function buildShades(card){
      var host=card.querySelector('.cc-shades'); if(!host||host.dataset.built) return;
      var html='<span class="cc-shade-lbl">Shade: <b class="cc-shade-cur">Light</b></span><div class="cc-shade-opts">';
      for(var s=0;s<SHADES.length;s++){
        html+='<button type="button" class="cc-shade-btn'+(s===0?' is-sel':'')+'" data-shade="'+SHADES[s]+'" aria-label="'+SHADES[s]+'" title="'+SHADES[s]+'"><span class="cc-sw" style="background:'+SWATCH[SHADES[s]]+'"></span></button>';
      }
      html+='</div>';
      host.innerHTML=html; host.dataset.built='1';
      host.querySelectorAll('.cc-shade-btn').forEach(function(btn){
        btn.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          host.querySelectorAll('.cc-shade-btn').forEach(function(b){b.classList.remove('is-sel');});
          btn.classList.add('is-sel');
          var cur=host.querySelector('.cc-shade-cur'); if(cur) cur.textContent=btn.dataset.shade;
          updateVariant();
        });
      });
    }
    function selectedCard(){ return root.querySelector('.cc-bundle.is-sel'); }
    function updateVariant(){
      var card=selectedCard(); if(!card) return;
      var bundle=card.dataset.bundle;
      var sel=card.querySelector('.cc-shade-btn.is-sel');
      var shade=sel?sel.dataset.shade:'Light';
      var vid=VARIANTS[bundle+'|'+shade];
      if(idField&&vid) idField.value=vid;
      state={bundle:bundle,shade:shade,variantId:vid};
    }
    function selectBundle(card){
      bundles.forEach(function(b){b.classList.remove('is-sel');var r=b.querySelector('input[type=radio]');if(r)r.checked=false;});
      card.classList.add('is-sel'); var r=card.querySelector('input[type=radio]'); if(r)r.checked=true;
      buildShades(card); updateVariant();
    }
    bundles.forEach(function(b){
      buildShades(b);
      b.addEventListener('click',function(ev){ if(ev.target.closest('.cc-shade-btn'))return; selectBundle(b); });
    });
    var pre=root.querySelector('.cc-bundle.is-sel')||bundles[0];
    if(pre) selectBundle(pre);

    /* ---- Add to Cart -> AJAX add (variant carries bundle+shade) + open cart drawer ---- */
    function addToCart(){
      var vid=state.variantId||(idField&&idField.value); if(!vid) return;
      var btns=root.querySelectorAll('.cc-atc'); btns.forEach(function(b){b.dataset.o=b.textContent;b.textContent='Adding…';b.disabled=true;});
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){
          var cd=document.querySelector('cart-drawer'), sec=cd&&cd.closest('.shopify-section');
          var secId=sec?sec.id.replace('shopify-section-',''):null;
          if(secId){ return fetch('/?section_id='+secId).then(function(r){return r.text();}).then(function(html){ if(sec) sec.innerHTML=html; }); }
        })
        .then(function(){
          var d=document.querySelector('cart-drawer');
          if(d&&typeof d.open==='function'){ d.classList.remove('is-empty','cart-drawer--empty'); d.open(); }
          else { window.location.href='/cart'; }
        })
        .catch(function(){ window.location.href='/cart'; })
        .then(function(){ root.querySelectorAll('.cc-atc').forEach(function(b){ if(b.dataset.o){b.textContent=b.dataset.o;b.disabled=false;} }); });
    }
    if(form){ form.addEventListener('submit',function(ev){ ev.preventDefault(); addToCart(); }); }

    /* ---- Sticky ATC ---- */
    var sticky=root.querySelector('.cc-sticky'), anchor=root.querySelector('.cc-buybox');
    if(sticky&&anchor){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0); });
      },{threshold:0});
      io.observe(anchor);
      var sbtn=sticky.querySelector('[data-sticky-atc]');
      if(sbtn){ sbtn.addEventListener('click',function(ev){ ev.preventDefault(); addToCart(); }); }
    }

    /* ---- Demo videos: play in view ---- */
    var dvids=root.querySelectorAll('.cc-demo video');
    if(dvids.length){
      var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});}else{try{v.pause();}catch(x){}}});},{threshold:0.25});
      dvids.forEach(function(v){v.muted=true;v.setAttribute('muted','');vio.observe(v);});
    }

    /* ---- Countdown timers ---- */
    root.querySelectorAll('[data-countdown]').forEach(function(el){
      var mins=parseInt(el.dataset.countdown,10)||10, end=Date.now()+mins*60000;
      function tick(){
        var d=end-Date.now(); if(d<0){end=Date.now()+mins*60000;d=mins*60000;}
        var h=Math.floor(d/3.6e6), m=Math.floor(d%3.6e6/6e4), s=Math.floor(d%6e4/1e3);
        el.textContent=(h>0?(h<10?'0':'')+h+':':'')+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
      }
      tick(); setInterval(tick,1000);
    });
  });
})();
